module.exports = __webpack_public_path__ + "be9b568247b778302b3f005ffda10250.svg";